import { TemplatePrompts } from '@kimuno/api-sdk/lib/types/common/Conversation';

import { routes } from '../../../constants';

export const AI_TOOLS_TEMPLATE_SEGMENT = 'vorlage';

// Static slugs, deliberately not derived from the localized titles: a copy or
// locale change must never break a shared template URL.
const templateSlugById: Partial<Record<TemplatePrompts, string>> = {
	[TemplatePrompts.CREATE_WORKSHEET_FREE_DRAFT]: 'arbeitsblatt-erstellen',
	[TemplatePrompts.CREATE_LESSON_PLAN_FREE_DRAFT]: 'unterrichtsstunde-planen',
	[TemplatePrompts.CREATE_GROUP_WORK_FREE_DRAFT]: 'gruppenaufgaben',
	[TemplatePrompts.CREATE_ESSAY_FREE_DRAFT]: 'essay-vorlage',
	[TemplatePrompts.CREATE_TOPIC_EXPLANATION_FREE_DRAFT]: 'thema-erklaeren',
	[TemplatePrompts.CREATE_LEARNING_OBJECTIVE_ASSERTION_FREE_DRAFT]: 'lernzielkontrolle-generieren',
	[TemplatePrompts.CREATE_LESSON_SERIES_FREE_DRAFT]: 'unterrichtsreihe-planen',
	[TemplatePrompts.CREATE_IMAGE]: 'bild-generieren',
	[TemplatePrompts.CREATE_PODCAST]: 'podcast-erstellen',
};

const templateIdBySlug = new Map<string, TemplatePrompts>(
	Object.entries(templateSlugById).map(([id, slug]) => [slug, id as TemplatePrompts])
);

export const getTemplateSlug = (id: TemplatePrompts): string | undefined => templateSlugById[id];

export const getTemplatePromptIdFromSlug = (slug: string): TemplatePrompts | undefined =>
	templateIdBySlug.get(slug);

export const getTemplateFormUrl = (id: TemplatePrompts): string | undefined => {
	const slug = templateSlugById[id];
	return slug ? `/${routes.aiTools.root}/${AI_TOOLS_TEMPLATE_SEGMENT}/${slug}` : undefined;
};
